import * as React from 'react';
import axios from 'axios';
import LogPlusAnyResourcesAutocomplete from './LogPlusAnyResourcesAutocomplete';
import { AutocompleteMode, IDeviceListItem, IRelatedDeviceListItem, KindsList, parseFromDevice, parseToDevice } from './IModels';
import LogPlusAutocompleteOption from './LogPlusAutocompleteOption';
import LogPlusRelatedDevicesAutocomplete from './LogPlusRelatedDevicesAutocomplete';

export interface GetDevicesAutocompleteResourcesResult {
	success: boolean,
	status?: "LogDisabled",
	items?: IDeviceListItem[]
}

interface IProps<T> {
	value: T[],
	onSelect: (value: T[]) => void,
    kinds: KindsList[],
	multiple?: true | false,
	placeholderText?: string,
	error?: boolean;
	helperText?: string,
    searchIn: string,
    mode: AutocompleteMode,
    notifier: { value: string, label: string },
    filterId: string,
    relatedFilterId: string,
}

export default function LogPlusDevicesAutocomplete(props: IProps<IDeviceListItem>) {

    function parseRelated() {
        let devices: IRelatedDeviceListItem[] = [];
        for (let i = 0; i < props.kinds.length; i++) {
            let kind = props.kinds[i];
            let databyKind = props.value[kind] as IDeviceListItem[];
            if (databyKind)
                devices = devices.concat(databyKind.map(parseFromDevice));
        }
        return devices;
    }

    function parseFromRelated(r: IRelatedDeviceListItem[]) {
        let data = { ...props.value };

        for (let i = 0; i < props.kinds.length; i++) {
            let kind = props.kinds[i];
            let devicesByKind = r
                .filter(x => x.HdKind === kind)
                .map(parseToDevice);

            data[kind] = devicesByKind as any[];
        }

        return data;
    }

    switch (props.mode) {
        case 'relatedUser':
        case 'relatedNotifier':
            return (<LogPlusRelatedDevicesAutocomplete
                searchIn={props.searchIn?.split(',') as (keyof IRelatedDeviceListItem)[]}
                notifierId={props.notifier?.value}
                mode={props.mode}
                error={props.error}
                helperText={props.helperText}
                kinds={props.kinds}
                multiple={props.multiple}
                value={parseRelated()}
                onSelect={(r) => {
                    let data = parseFromRelated(r);
                    props.onSelect(data);
                }}
                filterId={props.relatedFilterId}
            />);
        default:
            return (<DevicesAutocomplete
                value={props.value}
                onSelect={props.onSelect}

                searchIn={props.searchIn?.split(',') as (keyof IDeviceListItem)[]}
                error={props.error}
                helperText={props.helperText}
                kinds={props.kinds}
                multiple={props.multiple}
                filterId={props.filterId}
            />);
    }
}

interface IDevicesAutocompleteProps {
    value: IDeviceListItem[],
    onSelect: (value: IDeviceListItem[]) => void,
    kinds: string[],
    multiple?: true | false,
    placeholderText?: string,
    error?: boolean;
    helperText?: string,

    searchIn: (keyof IDeviceListItem)[],
    filterId: string;
}

function DevicesAutocomplete(props: IDevicesAutocompleteProps)
{
	const getOptionSelected = (option: IDeviceListItem, value: IDeviceListItem) => {
		return option.HdKind === value.HdKind && option.Id === value.Id;
	}

	return (<LogPlusAnyResourcesAutocomplete
		{...props}
		getOptionLabel={(option: IDeviceListItem) => option.Name}
		getOptionSelected={getOptionSelected}
		createRequest={(text: string) => {
			return {
				text: text,
			}
		}}
		loadOptions={(request, callback) => {

			axios.get<GetDevicesAutocompleteResourcesResult>('/LogPlusResources/GetDevicesAutocomplete/', {
				params: {
					search: request.text,
                    searchIn: props.searchIn?.join(','),
					max: 20,
                    kinds: props.kinds.join(','),
                    filterId: props.filterId,
				}
			})
				.then(r => {
					callback(r.data.items);
				});
		}}
		renderOption={option => <LogPlusAutocompleteOption
			kind={option.HdKind}
			name={option.Name}
			type={option.Type}

			searchIn={props.searchIn}
			item={option}
		/>}
	/>);
}